import React from "react";
import Report from "../../../components/Report/Report";

const AnnualReports = () => {
  return <Report type={"annual"} />;
};

export default AnnualReports;
